module.exports = __webpack_public_path__ + "img/icono-lambdas.3937d1dc.png";